import React from 'react';
import PropTypes from 'prop-types';

import RsStructure from '@Pages/RetroSynthesis/components/RsStructure';
import StepsCount from './StepsCount';
import './RsBuildingBlocks.theme.scss';

export const rsBuildingBlocksClassName = 'rs-building-blocks';
export const rsBuildingBlocksStartingMaterialsClassName = 'rs-building-blocks__structures';
export const rsBuildingBlocksStepsCountClassName = 'rs-building-blocks__steps-count';
export const rsBuildingBlocksProductClassName = 'rs-building-blocks__product';

function RsBuildingBlocks({
  routeType,
  structures = [],
  product,
  stepCount,
  displayStepCountLabel,
  synthesisMenuOptions,
  imagePathKey,
  onToolbarOptionOpen,
  onMenuItemClick,
  onOpenInDatabaseClick,
  onAutoSynthesizeClick,
  onShoppingCartOptionClick,
  showToolbar = true,
  showStepsCount = true,
  showOptions = true,
  showZoom = true,
  trackingContent,
}) {
  return (
    <div className={rsBuildingBlocksClassName}>
      <div className={rsBuildingBlocksStartingMaterialsClassName}>
        {structures.map((structure, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <React.Fragment key={`structure-${i}`}>
            <RsStructure
              routeType={routeType}
              structure={structure}
              synthesisMenuOptions={synthesisMenuOptions}
              imagePathKey={imagePathKey}
              onToolbarOptionOpen={onToolbarOptionOpen}
              onMenuItemClick={onMenuItemClick}
              onOpenInDatabaseClick={onOpenInDatabaseClick}
              onAutoSynthesizeClick={onAutoSynthesizeClick}
              onShoppingCartOptionClick={onShoppingCartOptionClick}
              showToolbar={showToolbar}
              showOptions={showOptions}
              showZoom={showZoom}
              trackingContent={trackingContent}
            />
            {structures.length - i > 1 && (
              <div className="rs-building-blocks__icon">
                <svg className="els-btn-icon icon-plus" aria-label="reactions-item-connector-plus">
                  <use xlinkHref="#icon-plus" />
                </svg>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
      {showStepsCount && (
        <StepsCount className={rsBuildingBlocksStepsCountClassName} value={stepCount} displayLabel={displayStepCountLabel} />
      )}
      {product && (
        <RsStructure
          className={rsBuildingBlocksProductClassName}
          routeType={routeType}
          structure={product}
          synthesisMenuOptions={synthesisMenuOptions}
          imagePathKey={imagePathKey}
          onToolbarOptionOpen={onToolbarOptionOpen}
          onMenuItemClick={onMenuItemClick}
          onOpenInDatabaseClick={onOpenInDatabaseClick}
          onAutoSynthesizeClick={onAutoSynthesizeClick}
          onShoppingCartOptionClick={onShoppingCartOptionClick}
          trackingContent={trackingContent}
        />
      )}
    </div>
  );
}

RsBuildingBlocks.defaultProps = {
  onToolbarOptionOpen: () => null,
  onMenuItemClick: () => null,
  onOpenInDatabaseClick: () => null,
  onAutoSynthesizeClick: () => null,
  onShoppingCartOptionClick: () => null,
};

RsBuildingBlocks.propTypes = {
  routeType: PropTypes.string,
  structures: PropTypes.array,
  product: PropTypes.object,
  stepCount: PropTypes.number,
  displayStepCountLabel: PropTypes.bool,
  synthesisMenuOptions: PropTypes.array,
  imagePathKey: PropTypes.string,
  onToolbarOptionOpen: PropTypes.func,
  onMenuItemClick: PropTypes.func,
  onOpenInDatabaseClick: PropTypes.func,
  onAutoSynthesizeClick: PropTypes.func,
  onShoppingCartOptionClick: PropTypes.func,
  showToolbar: PropTypes.bool,
  showStepsCount: PropTypes.bool,
  showZoom: PropTypes.bool,
  showOptions: PropTypes.bool,
  trackingContent: PropTypes.array,
};

export default RsBuildingBlocks;
